import React, { useState } from "react";
import {
  reactCode,
  vueCode,
  nextjsCode,
  nuxtCode,
  angularTsCode,
  svelteCode,
  htmlJsCode,
  wordpressCode,
  shopifyCode,
  phpCode,
  reactNativeCode,
  flutterCode,
  androidCode,
  iosCode,
  MOBILE_NOTES,
} from "../widgets/IntegrationCodes.js";

// Grouped so web frameworks, no-code/CMS, and native mobile read clearly.
const TABS = [
  { key: "react", label: "React", code: reactCode, group: "Web" },
  { key: "nextjs", label: "Next.js", code: nextjsCode, group: "Web" },
  { key: "vue", label: "Vue", code: vueCode, group: "Web" },
  { key: "nuxt", label: "Nuxt", code: nuxtCode, group: "Web" },
  { key: "angular", label: "Angular", code: angularTsCode, group: "Web" },
  { key: "svelte", label: "Svelte", code: svelteCode, group: "Web" },
  { key: "htmljs", label: "HTML / JS", code: htmlJsCode, group: "Web" },
  { key: "wordpress", label: "WordPress", code: wordpressCode, group: "No-code / CMS" },
  { key: "shopify", label: "Shopify", code: shopifyCode, group: "No-code / CMS" },
  { key: "php", label: "PHP", code: phpCode, group: "No-code / CMS" },
  { key: "reactnative", label: "React Native", code: reactNativeCode, group: "Mobile" },
  { key: "flutter", label: "Flutter", code: flutterCode, group: "Mobile" },
  { key: "android", label: "Android", code: androidCode, group: "Mobile" },
  { key: "ios", label: "iOS", code: iosCode, group: "Mobile" },
];

const GROUPS = ["Web", "No-code / CMS", "Mobile"];

export default function Integrations() {
  const [tab, setTab] = useState("react");
  const active = TABS.find((t) => t.key === tab) || TABS[0];

  return (
    <div>
      <h2 className="text-3xl font-bold mb-4">Embed Channels in Your Stack</h2>
      <p className="text-gray-700 mb-6">
        Use the examples below to integrate the Channels embed across frontend,
        no-code, and native mobile environments. Web setups use a trigger button
        and the <span className="font-mono">openChannelsWidget</span> call. For
        mobile, <span className="font-semibold">React Native</span> and{" "}
        <span className="font-semibold">Flutter</span> have native SDKs
        (<span className="font-mono">@channels-social/react-native</span>,{" "}
        <span className="font-mono">channels_flutter</span>) with passthrough
        auth; native Android and iOS use a WebView pointed at your embed URL.
      </p>

      {/* Grouped tab menu */}
      <div className="flex flex-col gap-2 mb-4 border-b pb-3">
        {GROUPS.map((group) => (
          <div key={group} className="flex items-center gap-2 flex-wrap">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-400 w-28 shrink-0">
              {group}
            </span>
            {TABS.filter((t) => t.group === group).map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-3 py-1.5 rounded-md text-sm font-medium ${
                  tab === t.key
                    ? "bg-blue-600 text-white"
                    : "text-gray-600 hover:text-blue-600 hover:bg-gray-100"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        ))}
      </div>

      <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto whitespace-pre-wrap">
        <code>{active.code}</code>
      </pre>
      <p className="text-gray-500 text-xs mt-1">
        (Replace{" "}
        <span className="font-mono">
          YOUR_API_KEY, YOUR_USER_ID, {"{CHANNEL_NAME}"}, {"{TOPIC_NAME}"},{" "}
          {"{USER_EMAIL}"}
        </span>{" "}
        with your real values.)
      </p>

      {MOBILE_NOTES[tab] && (
        <div className="mt-4 rounded-md border border-blue-200 bg-blue-50 p-4 text-sm text-gray-700">
          <p>
            <span className="font-semibold text-gray-800">Install:</span>{" "}
            <span className="font-mono">{MOBILE_NOTES[tab].install}</span>
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            {MOBILE_NOTES[tab].tips.map((t, i) => (
              <li key={i}>{t}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
